export async function fetchUserData(postId, userType) {
  try {
      // Fetch user details
      //console.log('Id1 :', user);
      console.log('usertype fetch :', userType);
      const userDetailsResponse = await fetch('https://yesedacademy.com/database/userProfile2.php', {
          method: 'POST',
          body: JSON.stringify({ postId, userType}),
          headers: {
              'Content-Type': 'application/json',
          },
      });

      if (!userDetailsResponse.ok) {
          throw new Error('Network response was not ok');
      }

      const userDetails = await userDetailsResponse.json();
     // console.log("iddd : ", user)
     // console.log('User details:', userDetails);

      // Fetch identification details
      const userIdentificationResponse = await fetch('https://yesedacademy.com/database/userIdentification.php', {
          method: 'POST',
          body: JSON.stringify({postId, userType}), // Assuming userId is the user ID
          headers: {
              'Content-Type': 'application/json',
          },
      });

      if (!userIdentificationResponse.ok) {
          throw new Error('Network response was not ok');
      }

      const userIdentification = await userIdentificationResponse.json();
      //console.log('Identification details:', userIdentification);


      // Merge user details and identification details
  

const renamedUserIdentification = Object.keys(userIdentification).reduce((acc, key) => {
  acc[`1`] = userIdentification[key];
  return acc;
}, {});
const details = Object.assign({}, userDetails, renamedUserIdentification);
//console.log('Merged user data:', details);


      return details;
  } catch (error) {
      throw new Error('Error fetching user data:', error);
  }
}
